export const studentFiltersAppliedEvent = 'filterintakepanel';
export const intakeQuestionsLoadedEvent = 'intakeQuestionsLoaded';
export const reportEnqueuedEvent = 'reportEnqueued';
